module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAR9JREFUSEvtlTFOw0AQRd9o3eMIBAVtelcoSBQUKThCJNJTcoAcIAfgDiBxCBd0gYgifQp8AERqZPORLSexgsGxYqIUcTnenTd/xv5jkhz/+Nh2AM+tgUS3SSFmhHQ+hpkCjfwQI0BMGoHkuex81l0CgDTQBCArOM+3B5R2dDdapJH/mA+qNy+zRqx6yEWZBcDi4rqxX7+iGtWWKa1WsMn/sBtD3iv46UUiwKzgporNHdxwFkVMbz3e76+lpA/mVbZPCjAmCzcl2wcqOqkPBIm5Kw9OpWQAtIE3IKoEpE5qttwHqxfil6NL9xWHiBlGCpuauSGH/Qfad/E6gPmZ8pU5Pr5Q8vm0SeK/Aenb8UmHVu+1bsWr6ra09Os0tebZb2w9HChP1bPIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imgs/user/icon-18.png
// module id = K+hG
// module chunks = 0